module.exports = __webpack_public_path__ + "img/public/SiteIcons/check.svg?016f94f9";